<template>
  <article id="startup-investment-info">
    <div class="row">
      <div class="col-6 item-data mt-1" v-if="invested">
        <h4>Primer Tramo (U$D)</h4>
        <p>{{numberWithDots(invested)}}</p>
      </div>
      <div class="col-6 item-data mt-1" v-if="followOn">
        <h4>Follow on (U$D)</h4>
        <p>{{numberWithDots(followOn)}}</p>
      </div>
      <div class="col-6 item-data mt-1" v-if="followOn">
        <h4>Total {{fund}} (U$D)</h4>
        <p>{{numberWithDots(invested+followOn)}}</p>
      </div>
      <div class="col-6 item-data mt-1" v-if="externalInvested">
        <h4>Inversión Externa</h4>
        <p>{{numberWithDots(externalInvested)}}</p>
      </div>
    </div>
    <div class="row constitution">
      <div class="col-9 item-data" v-if="constitutionDate">
        <h4>Fecha de constitución</h4>
        <p>{{constitutionDate}}</p>
      </div>
      <div class="col-3 item-data centered">
        <h4>Batch</h4>
        <p>{{batch}}</p>
      </div>
    </div>
    <div class="row principal-investors item-data" v-if="principalInvestors.length > 0">
      <div class="col-12">
        <h4>Inversores principales</h4>
      </div>
      <div class="col-3 investor-logo" v-for="(investor, i) in principalInvestorsFiltered" :key="i">
        <a :href="investor.website ? investor.website : '#'" target="_blank" rel="noopener">
          <img :src="investor.logo" :alt="investor.name" v-if="investor.logo" />
          <p v-else style="font-size:13px">{{investor.name}}</p>
        </a>
      </div>
    </div>
    <div class="row fondce" v-if="fondce">
      <div class="col-12 item-data">
        <h4>FONDCE (U$D)</h4>
        <p>{{fondce}}</p>
      </div>
    </div>
  </article>
</template>

<script>
import Moment from 'moment';
import { numberWithDots } from '../helpers/numbers';

export default {
  name: 'StartupInvestmentInfo',
  props: {
    invested: Number,
    followOn: Number,
    constitutionDate: String,
    batch: Number,
    principalInvestors: Array,
    fondce: String,
    externalInvested: Number,
  },
  computed: {
    principalInvestorsFiltered() {
      const repeatingInvestors = [];
      this.principalInvestors.forEach((investor, i) => {
        if (investor.name.indexOf('GRIDX') !== -1) {
          repeatingInvestors.push(i);
        }
      });
      repeatingInvestors.shift();

      return this.principalInvestors.filter((investor, i) => repeatingInvestors.indexOf(i) === -1);
    },
    selectedFondo() {
      return this.$store.state.selectedFondo;
    },
    fund() {
      if(this.selectedFondo === 'GRIDX2') return 'Fund II';
      return 'Fund I';
    },
  },
  data() {
    return {
      numberWithDots,
      Moment,
    };
  },
};
</script>

<style scoped lang="scss">
#startup-investment-info {
  margin-top: 15px;
}
.item-data {
  h4 {
    font-size: 12px;
    color: #979797;
    margin: 0;
    font-weight: 300;
    line-height: 1.5;
  }
  p {
    font-size: 16px;
    color: #330e2f;
    margin: 0;
    font-weight: 600;
  }
}

.centered {
  text-align: center;
}

.constitution,
.fondce {
  margin-top: 15px;
}

.principal-investors {
  margin-top: 15px;
  .investor-logo {
    padding-right: 0;
    margin-top: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70px;
    img {
      max-height: 70px;
    }
  }
}
</style>
